import { useNavBarHeight } from 'utils/hooks/useNavBarHeight';
import { Container, Sidebar } from './MissionControlHomePage.styled';
import { Launchpad } from './components/Launchpad';
import { MissionControlProvider } from './contexts/MissionControlContext';
import { ModalProvider } from './contexts/ModalContext';
import { Modals } from './modals';
import { DevPanel, DevPanelProvider, useIsDevPanelEnabled } from './components/DevPanel';
import { Dashboard } from './components/Dashboard';

export const HOMEPAGE_TEST_ID = 'mission-control-homepage';

const withHomePageContexts =
  <HomePageConsumerProps extends Record<string | number, unknown>>(
    HomePageConsumer: React.FC<HomePageConsumerProps>,
  ) =>
  (props: HomePageConsumerProps) => {
    return (
      <DevPanelProvider>
        <ModalProvider>
          <MissionControlProvider>
            <HomePageConsumer {...props} />
            <Modals />
          </MissionControlProvider>
        </ModalProvider>
      </DevPanelProvider>
    );
  };

export const MissionControlHomePage = withHomePageContexts(() => {
  const navBarHeight = useNavBarHeight();
  const isDevPanelEnabled = useIsDevPanelEnabled();

  return (
    <Container data-test={HOMEPAGE_TEST_ID} $navBarOffset={navBarHeight}>
      <Sidebar>
        <Launchpad />
      </Sidebar>

      <Dashboard />

      {isDevPanelEnabled && <DevPanel />}
    </Container>
  );
});
